module.exports = __webpack_public_path__ + "img/solar-panel.938edc3e.svg";